import React from "react";
import "../style/AboutPage.css";

function AboutPage() {
  return (
    <div className="about-page">
      <h1>About Conference-2026</h1>

      <section>
        <h2>About the Conference</h2>
        <p>
          The International Conference on Emerging Trends and
          Innovations in Engineering, Management and Technology
          aims to bring together researchers, academicians, industry
          experts, engineers, technologists, innovators and
          practitioners from around the world to exchange knowledge
          and discuss emerging trends in engineering technology and
          management.
        </p>

        <p>
          This conference focuses on major domains such as-
          Engineering, Technology, Scientific Research and
          Management Excellence, and highlights the
          interdisciplinary nature of modern innovation. In today’s
          rapidly evolving world, engineering and technology rely on
          scientific discovery, while scientific progress, in turn,
          depends heavily on the tools and systems engineered by
          technology experts. Similarly, effective management plays a
          crucial role in transforming these innovations into
          real-world applications, sustainable solutions, and impactful
          strategies.
        </p>

        <p>
          This international conference serves as a platform to explore
          these connections, encourage collaboration and inspire
          innovative solutions that contribute to societal development
          and global technological progress.
        </p>
      </section>

      <section>
        <h2>Conference Objectives</h2>

        <p>
          The International Conference on Emerging Trends and
          Innovations in Engineering, Management and Technology
          aims to provide a global platform for academicians,
          researchers and industry professionals to share knowledge
          and research outcomes. The conference will highlight
          advanced models, tools and technologies across engineering
          and management, with an emphasis on cutting-edge innovations,
          sustainable solutions, digital transformation, and
          data-driven decision-making
        </p>

        <p>
          The event will feature technical sessions with peer-reviewed
          papers, along with invited talks by leading academicians and
          industry experts offering insights into recent global developments.
        </p>

        <p>
          The official language of the conference is English
        </p>
      </section>
    </div>
  );
}

export default AboutPage;
